import axios from 'axios';
import { ApiResponseType } from '../../types/types';
import {
  AddPackageForUserResponse,
  GetMyPackageInfoResponse,
  GetPackagesResponse
} from './Maeketplace.types';
import { AKASHA, DASHBOARD, FLIPME_CARDS, TRADING } from '../../routes/routes';

export const getPackageAsync = async (): Promise<
  ApiResponseType<GetMyPackageInfoResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetMyPackageInfoResponse>>(
    `/package/my-package`
  );
  return data;
};

export const getPackagesAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `/package`
  );

  return data;
};

export const getPackagesTradingAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `/package/trading`
  );

  return data;
};

export const getPackagesBigWhaleAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `/package/big-whale`
  );

  return data;
};

export const getTravelPackagesAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `/package/revolution`
  );

  return data;
};

export const getFlipmeCardsAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `/package/flip-me`
  );

  return data;
};

export const getAkashaHubsAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `package/akasha`
  );

  return data;
};

export const getKriptoTapPackagesAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `package/kryptotap`
  );

  return data;
};

export const getDexNetPackagesAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `package/dexnet`
  );

  return data;
};

export const getGuardianNodesAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `package/guardian`
  );

  return data;
};

export const getDepositAkashaInfoAsync = async ({
  userPackageId
}: {
  userPackageId: string;
}) => {
  const { data } = await axios.get(
    `/package/akasha-deposit-info/${userPackageId}`
  );
  return data;
};

export const getAkashaWalletSummaryAsync = async () => {
  const { data } = await axios.get(`/my-hubs/wallet-summary`);
  return data;
};

export const depositAkashaAsync = async ({
  userPackageId,
  amount,
  token,
  chain
}: {
  userPackageId: number;
  amount: number;
  token: string | undefined;
  chain: string;
}) => {
  const { data } = await axios.post(`/package/akasha-deposit`, {
    userPackageId,
    amount,
    token,
    chain
  });
  return data;
};

export const addHubAsync = async ({
  packageId,
  currencyType,
  networkType,
  licenceId,
  userDiscountCodeId
}: {
  packageId: number;
  currencyType: number;
  networkType: number | null;
  licenceId: number | null;
  userDiscountCodeId: number | null;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const isTradingHubs =
    window.location.pathname === TRADING ||
    window.location.pathname === DASHBOARD;

  if (isTradingHubs) {
    const { data } = await axios.post<
      ApiResponseType<AddPackageForUserResponse>
    >(
      '/package/trading',
      currencyType === 1
        ? {
            packageId,
            currencyType,
            networkType,
            licenceId,
            userDiscountCodeId
          }
        : { packageId, currencyType, licenceId, userDiscountCodeId }
    );

    return data;
  } else {
    const { data } = await axios.post<
      ApiResponseType<AddPackageForUserResponse>
    >(
      `/package/user`,
      currencyType === 1
        ? {
            packageId,
            currencyType,
            networkType,
            licenceId
          }
        : { packageId, currencyType, licenceId }
    );

    return data;
  }
};

const checkPath = () => {
  switch (window.location.pathname) {
    case FLIPME_CARDS:
      return '/package/flip-me';

    default:
      return '/package/nft';
  }
};

export const purchaseNFTPackageAsync = async ({
  packageId,
  licenceId,
  lp,
  club,
  cash,
  usdt,
  usdc,
  networkType
}: {
  packageId: number;
  networkType: number | null;
  licenceId: number | null;
  lp: number;
  club: number;
  cash: number;
  usdt: number;
  usdc: number;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const { data } = await axios.post<ApiResponseType<AddPackageForUserResponse>>(
    checkPath(),
    {
      packageId,
      networkType,
      licenceId,
      lp,
      club,
      cash,
      usdt,
      usdc
    }
  );

  return data;
};

export const purchaseTradingPackageAsync = async ({
  packageId,
  licenceId,
  lp,
  club,
  cash,
  usdt,
  usdc,
  networkType,
  userDiscountCodeId
}: {
  packageId: number;
  networkType: number | null;
  licenceId: number | null;
  userDiscountCodeId: number | null;
  lp: number;
  club: number;
  cash: number;
  usdt: number;
  usdc: number;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const { data } = await axios.post<ApiResponseType<AddPackageForUserResponse>>(
    `/package/v2/trading`,
    {
      packageId,
      networkType,
      licenceId,
      lp,
      club,
      cash,
      usdt,
      usdc,
      userDiscountCodeId
    }
  );

  return data;
};

export const purchaseGuardianNodeAsync = async ({
  packageId,
  licenceId,
  lp,
  club,
  cash,
  usdt,
  usdc,
  networkType
}: {
  packageId: number;
  networkType: number | null;
  licenceId: number | null;
  lp: number;
  club: number;
  cash: number;
  usdt: number;
  usdc: number;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const { data } = await axios.post<ApiResponseType<AddPackageForUserResponse>>(
    `/package/guardian`,
    {
      packageId,
      networkType,
      licenceId,
      lp,
      club,
      cash,
      usdt,
      usdc
    }
  );

  return data;
};

export const purchaseDexNetPackageAsync = async ({
  packageId,
  licenceId,
  lp,
  club,
  cash,
  usdt,
  usdc,
  networkType
}: {
  packageId: number;
  networkType: number | null;
  licenceId: number | null;
  lp: number;
  club: number;
  cash: number;
  usdt: number;
  usdc: number;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const { data } = await axios.post<ApiResponseType<AddPackageForUserResponse>>(
    `/package/dexnet`,
    {
      packageId,
      networkType,
      licenceId,
      lp,
      club,
      cash,
      usdt,
      usdc
    }
  );

  return data;
};

export const purchasekriptoTapPackageAsync = async ({
  packageId,
  licenceId,
  lp,
  club,
  cash,
  usdt,
  usdc,
  networkType
}: {
  packageId: number;
  networkType: number | null;
  licenceId: number | null;
  lp: number;
  club: number;
  cash: number;
  usdt: number;
  usdc: number;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const { data } = await axios.post<ApiResponseType<AddPackageForUserResponse>>(
    `/package/kryptotap`,
    {
      packageId,
      networkType,
      licenceId,
      lp,
      club,
      cash,
      usdt,
      usdc
    }
  );

  return data;
};

export const purchaseBigWhalePackageAsync = async ({
  packageId,
  licenceId,
  lp,
  club,
  cash,
  usdt,
  usdc,
  networkType
}: {
  packageId: number;
  networkType: number | null;
  licenceId: number | null;
  lp: number;
  club: number;
  cash: number;
  usdt: number;
  usdc: number;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const { data } = await axios.post<ApiResponseType<AddPackageForUserResponse>>(
    `/package/big-whale`,
    {
      packageId,
      networkType,
      licenceId,
      lp,
      club,
      cash,
      usdt,
      usdc
    }
  );

  return data;
};

export const purchaseTravelPackageAsync = async ({
  packageId,
  licenceId,
  lp,
  club,
  cash,
  usdt,
  usdc,
  networkType
}: {
  packageId: number;
  networkType: number | null;
  licenceId: number | null;
  lp: number;
  club: number;
  cash: number;
  usdt: number;
  usdc: number;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const { data } = await axios.post<ApiResponseType<AddPackageForUserResponse>>(
    `/package/revolution`,
    {
      packageId,
      networkType,
      licenceId,
      lp,
      club,
      cash,
      usdt,
      usdc
    }
  );

  return data;
};

export const getTravelutionSubscriptionsAsync = async () => {
  const { data } = await axios.get(`/trevolution-subscription`);
  return data;
};

export const purchaseSubscriptionAsync = async ({
  packageId,
  licenceId,
  lp,
  club,
  cash,
  usdt,
  usdc,
  networkType
}: {
  packageId: number;
  networkType: number | null;
  licenceId: number | null;
  lp: number;
  club: number;
  cash: number;
  usdt: number;
  usdc: number;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const { data } = await axios.post<ApiResponseType<AddPackageForUserResponse>>(
    `/trevolution-subscription/buy`,
    {
      subscriptionId: packageId,
      networkType,
      club,
      cash,
      usdt,
      usdc
    }
  );
  return data;
};
